import { DropDownList } from "@progress/kendo-react-dropdowns";
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import Notifications from '../components/Notifications';
import { TelerikReportViewer } from '@progress/telerik-react-report-viewer/dist/cjs/main';
import { GetSession, GetToken } from '../components/Session';
import configData from "../config.json";
import { Button } from "@progress/kendo-react-buttons";
import { useNavigate, useParams } from "react-router-dom";

const ReportViewer = (props) => {
    let viewer;
    const navigate = useNavigate();
    let FromDate = props.dateRange.start === null ? "2000-01-01T00:00:00Z" : props.dateRange.start;
    let ToDate = props.dateRange.end === null ? "2040-01-01T00:00:00Z" : props.dateRange.end;
    var offset = -(props.dateRange.end.getTimezoneOffset() / 60);
    const removeCSS = () => {
        document.querySelector("link[href='" + configData.SERVER_URL + "apiv7/reports/resources/font/fonticons-19.2.25.1001.css/']").remove();

    }
    const GetSites = () => {
        let r = "";
        if (props.sites !== undefined && props.sites !== null) {
            props.sites.forEach(x => r += (r !== "" ? "," : "") + x.id);
        }
        return r;
    }

    const GetList = (d) => {
        let r = "";
        if (d !== undefined && d !== null) {
            d.forEach(x => r += (r !== "" ? "," : "") + x);
        }
        return r;
    }
    const GetDataList = (d) => {
        let r = "";
        if (d !== undefined && d !== null) {
            d.forEach(x => r += (r !== "" ? "," : "") + x.id);
        }
        return r;
    }

    let rs = {
        report: props.name + '.trdp',
        parameters: {
            'Url': props.url.replace(/.$/, ""),
            'Token': props.token,
            'TransactionDate': FromDate,
            'EndDate': ToDate,
            'Site': GetSites(),
            'offset': offset,
            'company': props.company,
            'Address': props.address,
            'LoadTypes': GetList(props.loadTypes),
            'Payments': GetList(props.payments),
            'Directions': GetList(props.directions),
            'VehicleTypes': GetList(props.vehicles),
            'ChargeTypes': GetList(props.chargeTypes),
            'Customer': GetDataList(props.customers),
            'Product': GetDataList(props.products),
            'Jobs': GetDataList(props.jobs),
            'Trucks': GetDataList(props.trucks),
            'Category': GetDataList(props.categories),
            'Users': GetDataList(props.users),
            'Source': GetDataList(props.sources),
            'Destination': GetDataList(props.destinations),
            'VehicleConfigurations': GetDataList(props.vehicleConfigurations)
        },
        headers: {}
    };
    const exportCsv = async (event, args) => {
        if (args.format?.toUpperCase() !== 'CSV') return;
        args.handled = true;
        try {
            const source = viewer.getReportSource();
            const response = await fetch(props.url + 'apiv7/reports/csv', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + props.token
                },
                body: JSON.stringify(source)
            });
            if (!response.ok) throw new Error('CSV export failed');
            const url = URL.createObjectURL(await response.blob());
            const link = document.createElement('a');
            link.href = url;
            link.download = props.name + '.csv';
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (error) {
            console.error('CSV export failed', error);
            window.alert('The CSV report could not be downloaded. Please try again.');
        }
    };
    return (
        <div className="report">
            <TelerikReportViewer
                ref={el => viewer = el}
                serviceUrl={props.url + "apiv7/reports/"}
                authenticationToken={props.token}
                exportBegin={exportCsv}
                ready={removeCSS}
                parameters={{
                    editors: {
                        multiSelect: 'COMBO_BOX'
                    }
                }}
                reportSource={rs}
                viewerContainerStyle={{
                    position: 'absolute',
                    left: '0px',
                    right: '0px',
                    top: '0px',
                    bottom: '0px',

                }}
                //templateUrl="telerikReportViewer-17.1.23.718.html"
                viewMode="PRINT_PREVIEW"
                pageMode="SINGLE_PAGE"
                scaleMode="FIT_PAGE_WIDTH"
                scale="0.3"
                documentMapAreaPosition="RIGHT"
                enableAccessibility={true} /></div>
    );
};
export default ReportViewer;
